import {createElement} from 'react';
import {HeadTag, Meta} from 'react-head';

const HeadTagSsrOnly = HeadTag;

// 删除所有client刷新meta（以及其他head部位）的动作
HeadTagSsrOnly.prototype.componentDidMount = () => {
  // nothing
};

HeadTagSsrOnly.prototype.componentWillUnmount = () => {
  // nothing
};

const Title = function(props) {
  return createElement(HeadTag, Object.assign({
    tag: 'title',
  }, props));
};
const Style = function(props) {
  return createElement(HeadTag, Object.assign({
    tag: 'style',
  }, props));
};
const Meta = function(props) {
  return createElement(HeadTag, Object.assign({
    tag: 'meta',
  }, props));
};
const Link = function(props) {
  return createElement(HeadTag, Object.assign({
    tag: 'link',
  }, props));
};

export {Title, Style, Meta, Link, HeadTagSsrOnly};
